import React from "react";
import { useTranslation } from "react-i18next";
// Styling
import { Group, Button, ActionIcon } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
//
import type { Step } from "@neuromotion-inc/mightier-survey-engine";

interface MobileNavigationButtonProps {
  currentStepIndex: number;
  goToPreviousStep: () => void;
  disabledSubmit: boolean;
  handleSubmit: () => Promise<void>;
  currentStep: Step;
}

export const MobileNavigationButton: React.FC<MobileNavigationButtonProps> = (
  props,
) => {
  const {
    currentStepIndex,
    goToPreviousStep,
    disabledSubmit,
    handleSubmit,
    currentStep,
  } = props;

  const { t } = useTranslation("mightier_survey_lib");

  return (
    <Group
      mt="xs"
      align="center"
      justify="center"
      style={{ gap: "1rem" }} // Adjust spacing between items
    >
      {currentStepIndex !== 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActionIcon
            variant="filled"
            radius="xl"
            onClick={goToPreviousStep}
            size="lg" // Adjust size if necessary
          >
            <IconChevronLeft />
          </ActionIcon>
        </div>
      )}
      <Button
        onClick={handleSubmit}
        disabled={disabledSubmit}
        style={{ textAlign: "center" }}
      >
        {t(currentStep.submit_button.text_translation_key)}
      </Button>
    </Group>
  );
};
